import { LinkedExchangeAccounts, LinkedExchange } from "@/types/moonscape";

export function getExchangeValues(data: LinkedExchangeAccounts | undefined) {
  if (!data) return [];

  // Merge oauth and api arrays, prioritizing the latest synced
  const merged = [...(data?.oauth || []), ...(data?.api || [])].reduce(
    (acc, item) => {
      const existing = acc[item.exchange];
      // Handle both snake_case (last_sync) and camelCase (lastSynced) during migration
      const itemLastSync = (item as any).last_sync || (item as any).lastSynced;
      const existingLastSync = existing ? ((existing as any).last_sync || (existing as any).lastSynced) : null;

      if (
        !existing ||
        new Date(itemLastSync || 0) > new Date(existingLastSync || 0)
      ) {
        acc[item.exchange] = item;
      }
      return acc;
    },
    {} as Record<string, LinkedExchange>
  );

  return Object.values(merged).map((item: LinkedExchange) => {
    // Safely extract exchangename as string
    const exchangeName = typeof item?.exchangename === 'string'
      ? item.exchangename
      : ((item?.exchangename as any)?.exchangename || item?.exchange || "Unknown");

    // For OAuth keys, integration_id will be null - fallback to exchange ID
    const integrationId = item.integration_id || item.exchange;

    return {
      id: integrationId,
      integration_id: item.integration_id,  // Keep original (may be null for OAuth)
      name: exchangeName,
      href: `/integration/${integrationId}`,  // Use integration_id or exchange ID as fallback
      initial: exchangeName.charAt(0),
      current: false,
      // Handle both snake_case and camelCase during migration
      thumbnailUrl: (item as any).thumbnail_url || (item as any).thumbnailUrl,
      status: item.status,
      syncStatus: (item as any).syncStatus,
      lastSynced: (item as any).last_sync || (item as any).lastSynced,
      is_csv: (item as any).is_csv || false,
    };
  });
}
